import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const contentWrapper = css`
  display: flex;
  height: 100%;
`;

export const leftSideWrapper = css`
  padding: 25px 30px;
  width: 548px;
`;

export const rightSideWrapper = css`
  background: rgba(244, 247, 249, 0.5);
  width: 352px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const headerIconLine = css`
  display: flex;
  gap: 5px;
  margin-bottom: 10px;

  > svg {
    color: ${colors.primary.default};
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export const selectWrapper = css`
  margin-top: 35px;

  & > *:first-child {
    display: flex;
    gap: 4px;
  }

  & > *:last-child {
    min-width: 300px;
    margin-top: 10px;
    width: max-content;

    & > *:nth-child(3) {
      max-height: 210px;
      min-width: 300px;
      width: fit-content;
      border-width: 1px 1px 1px 1px;
      margin-top: -1px;

      > div {
        max-height: 200px;
        min-width: 298px;
        width: fit-content;

        > div {
          width: 100%;
          min-width: 285px;

          > div {
            width: 100%;
          }
        }
      }
    }
  }
`;

export const groupTooltipCounter = css`
  display: flex;
  gap: 4px;
`;
